module.exports = __webpack_public_path__ + "static/media/nimes_roemermuseum_tn.c4f44002.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_roemermuseum_tn.jpg
// module id = 736
// module chunks = 0